export default function isCSSColor(color) {
	if (!color) return false

	if (color === 'transparent') return true
	if (color === 'currentColor') return true
	if (color.startsWith('#')) return true
	if (color.startsWith('rgb')) return true
	if (color.startsWith('lch')) return true
	if (color.startsWith('hsl')) return true
	if (color.startsWith('lab')) return true
	if (color.startsWith('color(')) return true

	return false
}
